import { createFileRoute } from '@tanstack/react-router'
import MarketingModelosEmailsEditorPage from '@/pages/dashboard/marketing-modelos-emails-editor-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/$templateId',
)({
  component: function MarketingModelosEmailsEditRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingModelosEmailsEditorPage mode="edit" />
      </RequireModule>
    )
  },
})
